
const VERSION   = '1.0.1';

// контекст СЕЛЕКТОРА: [attr="<тут>"] и :contains("<тут>") — ломают только " и \
export const escapeAttrValue = (v) => String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const hlp  = {
	slidersToReinit : [],	
	isCursor: () => window.matchMedia('(pointer: fine)').matches,
	syncButtons: function( currEl, type ) {
    	const btnType = currEl.data('button-' + type );
    	const switchButtons = btnType ? $( `[data-button-${type}="${escapeAttrValue(btnType)}"]` ) : currEl;
    	switchButtons.each( function() {
		    if( $(this).hasClass('icon_inlined') ) {
				$(this).toggleClass( 'btn-light btn-dark' );
				$(this).toggleClass( 'icon_pre-compare icon_pre-compare-white' );
		    } else {
          		$(this).toggleClass( 'active' );
		    }
    	});
	},
	throttle: function( mainFunction, delay ) {
	    let timerFlag = null;
	    return( ...args ) => {
	        if (timerFlag === null) {        
	            mainFunction(...args);
	            timerFlag = setTimeout( () => { timerFlag = null; }, delay );
	        }
	    };
	},
	addSliderToReinit: ( sliderId ) => { 
		hlp.slidersToReinit.indexOf( sliderId ) === -1 && hlp.slidersToReinit.push( sliderId )
	},
	getSlidersToReinit: () => hlp.slidersToReinit,
	isSliderToReinit: ( sliderId ) => hlp.slidersToReinit.indexOf( sliderId ) !== -1,
	unsetSliderToReinit: ( sliderId ) => {
		hlp.slidersToReinit.forEach( ( el, ind) => {
		    if( el === sliderId ) {
		        hlp.slidersToReinit.splice( ind, 1 );
		    }
		});
	},
	catalogMenuColumns: () => {
    	return $(window).width() >= 1199 ? 3 : 2;
	},
	isElementInViewport: ( el ) => {
	    const headerHeight = document.querySelector('.header').offsetHeight;
	    const rect = el.getBoundingClientRect();
	    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

	    if( rect.width + rect.height == 0 )
	        return false;

	    return rect.top + headerHeight >= headerHeight && rect.bottom <= windowHeight;
	},

}